'use client';

import * as ReactDOM from 'react-dom';
const unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;
export { unstable_batchedUpdates };